import _ from "lodash";

import { CollectionAdapter } from "../../../main/adapters/CollectionAdapter/CollectionAdapter";

const PopulateManagerCollection = new Mongo.Collection("PopulateManager", {
    connection: null
});

/**
 * @class
 * Responsavel por cuidar dos dados do commentarios usados no dashboard
 *
 *
 */
export class PopulateManager extends CollectionAdapter {
    constructor() {
        super(PopulateManagerCollection);
    }

    /**
     * @public
     * Retorna series que ainda não foram populadas
     */
    differenceBy(collectionName, inputIds) {
        const populatedSeries = this.findOneCollection({
            collections: collectionName
        });

        let seriesIds = inputIds;
        let response = {};
        response.serieIdsExcludes = [];

        if (populatedSeries) {
            seriesIds = _.differenceBy(inputIds, populatedSeries.ids);

            response.serieIdsExcludes = populatedSeries.ids;
        }

        response.seriesIds = seriesIds;

        return response;
    }
}
